module.exports = __webpack_public_path__ + "img/side-logo.7cb9769b.svg";